export default __webpack_public_path__ + "static/media/AddNotes.4762bb14.jpg";